import React, { useCallback, useEffect, useState } from "react";
import TypeToken from "./TypeToken";
import ValidationToken from "./ValidationToken";
import SideBanner from "components/layout/SideBanner";
import { Body, Container, Content } from "./styles";
import { useMFAContext } from "hooks/useMFA";
import { useHistory } from "react-router-dom";
import { useAuth } from "hooks/authHook";

const MFARegister = () => {
  const [steppers] = useState(["Envio do token", "Validação do token"]);
  const [step, setStep] = useState(1);
  const [userInfo, setUserInfo] = useState({});
  const [contactId, setContactId] = useState(null);

  const history = useHistory();
  const { contacts } = useAuth();
  const {
    credentials: { login },
    userId,
  } = useMFAContext();
  
  const storedUserId = localStorage.getItem("@UltragazEmpresarial:userIdMFA");

  useEffect(() => {
    const effectiveUserId = userId || storedUserId;

    async function loadData() {
      try {
        setUserInfo({
          document: login,
          userId: effectiveUserId,
          contacts: contacts || [],
        });
      } catch (error) {
        history.push("/");
      } finally {
        sessionStorage.removeItem("@UltragazEmpresarial:userIdMFA");
      }
    }

    if (login && effectiveUserId) {
      loadData();
    }
}, [login, userId]);

  const buildComponente = useCallback(() => {
    return (
      {
        1: (
          <TypeToken
            step={step}
            setStep={setStep}
            userInfo={userInfo}
            setUserInfo={setUserInfo}
            setContactId={setContactId}
          />
        ),
        2: (
          <ValidationToken
            step={step}
            setStep={setStep}
            userInfo={userInfo}
            setUserInfo={setUserInfo}
            contactId={contactId}
          />
        ),
      }[step] || (
        <TypeToken
          step={step}
          setStep={setStep}
          userInfo={userInfo}
          setUserInfo={setUserInfo}
          setContactId={setContactId}
        />
      )
    );
  }, [step, userInfo, setUserInfo, setStep]);

  const buildHeader = (step) => {
    return (
      {
        1: {
          h1: "Duplo fator de Autenticação",
          h2: "Informe de que forma deseja receber o código",
        },
        3: {
          h1: "Insira o código",
          h2: `Informe o código recebido`,
        },
      }[step] || { h1: "", h2: "" }
    );
  };

  return (
    <Container>
      <SideBanner
        activated={step}
        header={buildHeader(step)}
        steppers={steppers}
      />
      <Content>
        <Body>{buildComponente()}</Body>
      </Content>
    </Container>
  );
};

export default MFARegister;
